// components/ChatTags/index.js
import React from 'react';
import { Box, Chip, Stack, Tooltip } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import './styles.css';

const ChatTags = ({ tags = [], maxVisible = 3, size = 'small' }) => {
  const visibleTags = tags.slice(0, maxVisible);
  const hiddenTags = tags.slice(maxVisible);
  const hasHiddenTags = hiddenTags.length > 0;

  return (
    <Box className="chat-tags-container">
      <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap">
        {visibleTags.map((tagItem) => (
          <TagChip key={tagItem.tagid} tag={tagItem.tag} size={size} />
        ))}
        
        {hasHiddenTags && (
          <Tooltip 
            title={
              <Stack spacing={0.5}>
                {hiddenTags.map((tagItem) => (
                  <span key={tagItem.tagid}>{tagItem.tag.name}</span>
                ))}
              </Stack>
            }
            arrow
          >
            <Chip
              label={`+${hiddenTags.length}`}
              size={size}
              variant="outlined"
              className="more-tags-chip"
              sx={{
                height: size === 'small' ? 20 : 24,
                fontSize: size === 'small' ? '0.7rem' : '0.75rem',
                borderColor: '#ccc',
                color: '#666',
                '& .MuiChip-label': {
                  px: 1,
                },
              }}
            />
          </Tooltip>
        )}
      </Stack>
    </Box>
  );
};

const TagChip = ({ tag, size }) => {
  // Função para gerar cor baseada no nome da tag
  const getTagColor = (tagName) => {
    const colors = [
      { bg: '#e3f2fd', text: '#1565c0' }, // Azul
      { bg: '#f3e5f5', text: '#6a1b9a' }, // Roxo
      { bg: '#e8f5e9', text: '#2e7d32' }, // Verde
      { bg: '#fff3e0', text: '#e65100' }, // Laranja
      { bg: '#fce4ec', text: '#c2185b' }, // Rosa
      { bg: '#e0f2f1', text: '#00695c' }, // Teal
      { bg: '#f1f8e9', text: '#558b2f' }, // Verde claro
      { bg: '#ede7f6', text: '#4527a0' }, // Roxo escuro
    ];
    
    // Gera um índice baseado no hash do nome
    let hash = 0;
    for (let i = 0; i < tagName.length; i++) {
      hash = tagName.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % colors.length;
    return colors[index];
  };

  const color = getTagColor(tag.name);

  return (
    <Tooltip title={tag.name} arrow placement="top">
      <Chip
        icon={<LocalOfferIcon />}
        label={tag.name}
        size={size}
        className="tag-chip"
        sx={{
          backgroundColor: color.bg,
          color: color.text,
          border: `1px solid ${color.text}20`,
          height: size === 'small' ? 20 : 24,
          fontSize: size === 'small' ? '0.7rem' : '0.75rem',
          fontWeight: 500,
          '& .MuiChip-icon': {
            color: color.text,
            fontSize: size === 'small' ? '0.9rem' : '1rem',
            ml: 0.5,
          },
          '& .MuiChip-label': {
            px: 1,
            py: 0,
          },
          maxWidth: '150px',
          '&:hover': {
            backgroundColor: color.text + '10',
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          },
          transition: 'all 0.2s ease',
        }}
      />
    </Tooltip>
  );
};

export default ChatTags;